import { Injectable } from '@angular/core';
import { ITenant } from 'onego-header';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { DerivedStateValue, IUser, StateValue } from 'shared';

import { ISocketStatus } from '../socket.service';

@Injectable({ providedIn: 'root' })
export class AppStateService {
    //
    // States
    //
    public readonly user = new StateValue<IUser>(null);
    public readonly users = new StateValue<Array<IUser>>();
    public readonly serviceTokenUsers = new StateValue<Array<IUser>>();
    public readonly activeTenantId = new StateValue<string>();
    public readonly socketStatus = new StateValue<ISocketStatus>({ status: 'DISCONNECTED' });
    public readonly activeTasksForUser = new StateValue<Array<string>>([]);
    public readonly returnUrl = new StateValue<string>(null);

    //
    // Derived States
    //
    public readonly activeTenant = new DerivedStateValue<ITenant>(
        combineLatest([this.activeTenantId.distinctStream, this.user.distinctStream]).pipe(
            map(([activeTenantId, user]) => user?.tenants.find((tenant) => tenant.id === activeTenantId))
        )
    );

    public readonly loggedInWithTenant = new DerivedStateValue<boolean>(
        combineLatest([this.activeTenant.distinctStream, this.user.distinctStream]).pipe(
            map(([user, tenant]) => !!user && !!tenant)
        )
    );
}
